import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  empty_list: 'Aún no hay productos.',
  fields: {
    number: '#',
    image: 'Imagen',
    name: 'Nombre',
    external_id: 'Ref. de {{integration}}',
    price: 'Precio',
    prices: 'Precios',
    description: 'Descripción',
    tags: 'Etiquetas',
    status: 'Estado',
    product_type: 'Tipo',
    statuses: {
      good: 'Bueno',
      bad: 'Malo',
      medium: 'Medio',
    },
    product_types: {
      packaged: 'Empaquetado',
      prepared: 'Preparado',
    },
  },
  labels: {
    visible: 'Visible en el menú',
    hidden: 'Todos ocultos',
  },
  order_method_prices: {
    base: 'Base',
    [ORDER_METHODS.pickup]: 'Recogida',
    [ORDER_METHODS.delivery]: 'Entrega',
    [ORDER_METHODS.room_service]: 'Servicio en mesa',
  },
  buttons: {
    delete_products_one: 'Eliminar producto',
    delete_products_other: 'Eliminar productos',
    add_product: '+ Añadir producto',
    show_products: 'Mostrar productos',
    hide_products: 'Ocultar productos',
    add: 'Añadir',
    edit: 'Editar',
    duplicate: 'Duplicar',
    history: 'Historial',
    delete: 'Eliminar',
    delete_all: 'Eliminar todo',
  },
  toasts: {
    failed_to_duplicate_category: 'Error al duplicar la categoría',
    category_duplicated_successfully: 'Categoría duplicada correctamente',
    failed_to_duplicate_product: 'Error al duplicar el producto',
    product_duplicated_successfully: 'Producto duplicado correctamente',
    failed_to_delete_variant: 'Error al eliminar la variante',
    variant_got_deleted: 'Variante eliminada',
    something_went_wrong: 'Algo salió mal',
  },
};
